import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  error: {
    '&&': {
      marginBottom: '2rem',
    },
  },
}));
